import { __decorate, __metadata } from "tslib";
import { IsGreaterThanOrEqual } from '@goparrot/common';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsInstance, IsNotEmpty, IsNumber, IsOptional, IsString, Min, ValidateIf, ValidateNested } from 'class-validator';
import { StoreItemPropertiesRequiredEnum, StoreItemsExposeGroup } from '../enum';
import { ReadStoreItemPropertiesItemBaseOverridesDto } from './ReadStoreItemPropertiesItemBaseOverridesDto';
export class ReadStoreItemPropertiesDto {
}
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemPropertiesDto.prototype, "uid", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadStoreItemPropertiesDto.prototype, "isDisabled", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemPropertiesDto.prototype, "showOrder", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadStoreItemPropertiesItemBaseOverridesDto),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadStoreItemPropertiesItemBaseOverridesDto, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadStoreItemPropertiesDto.prototype, "itemBaseOverrides", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    Min(0, { always: true }),
    ValidateIf((_object, value) => value !== 0, { always: true }),
    IsGreaterThanOrEqual('minSelections', { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemPropertiesDto.prototype, "maxSelections", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemPropertiesDto.prototype, "minSelections", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsEnum(StoreItemPropertiesRequiredEnum, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemPropertiesDto.prototype, "required", void 0);
__decorate([
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadStoreItemPropertiesDto.prototype, "mandatory", void 0);
//# sourceMappingURL=ReadStoreItemPropertiesDto.js.map